<icc-list [searchable]="true" [items]="glazingBeads"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          [selected]="selectedBeadId"
          (select)="selectBead($event)"></icc-list>
